import React, { useState } from 'react';
import { Search, MoreVertical, ChevronLeft, Paperclip, Smile, Mic, Check, Phone, Video, User, Clock, Edit, Trash2, Info } from 'lucide-react';

// Mock data for contacts and conversations
const contacts = [
  { id: 1, name: 'John Doe', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'Hey, how are you?', time: '10:30 AM', unread: 2 },
  { id: 2, name: 'Jane Smith', avatar: '/api/placeholder/50/50', lastSeen: '2 hours ago', lastMessage: 'Meeting at 3 PM tomorrow', time: 'Yesterday', unread: 0 },
  { id: 3, name: 'Alex Johnson', avatar: '/api/placeholder/50/50', lastSeen: '5 mins ago', lastMessage: 'Did you get the files?', time: 'Yesterday', unread: 0 },
  { id: 4, name: 'Sarah Williams', avatar: '/api/placeholder/50/50', lastSeen: 'yesterday', lastMessage: 'Thanks for your help!', time: 'Sunday', unread: 1 },
  { id: 5, name: 'Mike Brown', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'Let me check and get back to you', time: 'Sunday', unread: 0 },
  { id: 6, name: 'Emily Davis', avatar: '/api/placeholder/50/50', lastSeen: '2 days ago', lastMessage: 'I\'ll be there in 10 mins', time: 'Saturday', unread: 0 },
  { id: 7, name: 'Chris Wilson', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'I\'ll send you the details shortly', time: 'Saturday', unread: 0 },
  { id: 8, name: 'Jessica Lee', avatar: '/api/placeholder/50/50', lastSeen: '3 days ago', lastMessage: 'I\'ll be there in 10 mins', time: 'Friday', unread: 0 },
  { id: 9, name: 'David Moore', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'I\'ll send you the details shortly', time: 'Friday', unread: 0 },
  { id: 10, name: 'Lisa Taylor', avatar: '/api/placeholder/50/50', lastSeen: '4 days ago', lastMessage: 'I\'ll be there in 10 mins', time: 'Thursday', unread: 0 },
  { id: 11, name: 'Mark Anderson', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'I\'ll send you the details shortly', time: 'Thursday', unread: 0 },
  { id: 12, name: 'Karen Thomas', avatar: '/api/placeholder/50/50', lastSeen: '5 days ago', lastMessage: 'I\'ll be there in 10 mins', time: 'Wednesday', unread: 0 },
  { id: 13, name: 'Paul Jackson', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'I\'ll send you the details shortly', time: 'Wednesday', unread: 0 },
  { id: 14, name: 'Laura White', avatar: '/api/placeholder/50/50', lastSeen: '6 days ago', lastMessage: 'I\'ll be there in 10 mins', time: 'Tuesday', unread: 0 },
  { id: 15, name: 'Kevin Harris', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'I\'ll send you the details shortly', time: 'Tuesday', unread: 0 },
  { id: 16, name: 'Helen Martinez', avatar: '/api/placeholder/50/50', lastSeen: '1 week ago', lastMessage: 'I\'ll be there in 10 mins', time: 'Monday', unread: 0 },
  { id: 17, name: 'Steven Young', avatar: '/api/placeholder/50/50', lastSeen: 'online', lastMessage: 'I\'ll send you the details shortly', time: 'Monday', unread: 0 },
  { id: 18, name: 'Amanda King', avatar: '/api/placeholder/50/50', lastSeen: '2 weeks ago', lastMessage: 'I\'ll be there in 10 mins', time: 'Sunday', unread: 0 },
];

const initialMessages = [
  { id: 1, text: 'Hey there!', time: '10:25 AM', sender: 'other', status: 'read' },
  { id: 2, text: 'How are you doing?', time: '10:26 AM', sender: 'other', status: 'read' },
  { id: 3, text: 'I\'m good, thanks! Working on that project we discussed.', time: '10:28 AM', sender: 'me', status: 'read' },
  { id: 4, text: 'Making good progress. Should be able to share a draft by tomorrow.', time: '10:28 AM', sender: 'me', status: 'read' },
  { id: 5, text: 'That sounds great! Looking forward to seeing it.', time: '10:30 AM', sender: 'other', status: 'read' },
  { id: 6, text: 'Do you need any help with anything?', time: '10:30 AM', sender: 'other', status: 'read' },
  { id: 7, text: 'I think I\'m good for now. But I might need your input on the design later.', time: '10:31 AM', sender: 'me', status: 'sent' },
];

const WhatsAppClone = () => {
  const [activeContact, setActiveContact] = useState(window.innerWidth >= 768 ? contacts[0] : null);
  const [messages, setMessages] = useState(initialMessages);
  const [newMessage, setNewMessage] = useState('');
  const [showContactInfo, setShowContactInfo] = useState(false);
  const [editingMessage, setEditingMessage] = useState(null);
  const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, messageId: null });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleSendMessage = () => {
    if (newMessage.trim() === '') return;
    
    if (editingMessage) {
      // Update existing message
      setMessages(messages.map(msg => 
        msg.id === editingMessage ? { ...msg, text: newMessage, edited: true } : msg
      ));
      setEditingMessage(null);
    } else {
      // Add new message
      const newMsg = {
        id: messages.length + 1,
        text: newMessage,
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        sender: 'me',
        status: 'sent'
      };
      setMessages([...messages, newMsg]);
    }
    setNewMessage('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendMessage();
    }
  };

  const handleMessageContextMenu = (e, messageId) => {
    e.preventDefault();
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      messageId
    });
  };

  const handleEditMessage = (messageId) => {
    const message = messages.find(msg => msg.id === messageId);
    if (message && message.sender === 'me') {
      setEditingMessage(messageId);
      setNewMessage(message.text);
      setContextMenu({ ...contextMenu, visible: false });
    }
  };

  const handleDeleteMessage = (messageId) => {
    setMessages(messages.filter(msg => msg.id !== messageId));
    setContextMenu({ ...contextMenu, visible: false });
  };

  const handleClickOutside = () => {
    setContextMenu({ ...contextMenu, visible: false });
  };
  
  // Handle window resize
  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Status icon component
  const MessageStatus = ({ status }) => {
    if (status === 'sent') {
      return <Check className="h-3 w-3 text-gray-400" />;
    } else if (status === 'delivered') {
      return (
        <div className="flex">
          <Check className="h-3 w-3 text-gray-400" />
          <Check className="h-3 w-3 text-gray-400 -ml-1" />
        </div>
      );
    } else if (status === 'read') {
      return (
        <div className="flex">
          <Check className="h-3 w-3 text-blue-500" />
          <Check className="h-3 w-3 text-blue-500 -ml-1" />
        </div>
      );
    }
    return null;
  };

  return (
    <div className="flex h-screen bg-gray-100 overflow-hidden" onClick={handleClickOutside}>
      {/* Left sidebar - Contacts (hidden on mobile unless no active chat) */}
      <div className={`md:w-1/3 border-r border-gray-300 bg-white ${
        showContactInfo ? 'hidden md:block' : 
        activeContact && windowWidth < 768 ? 'hidden' : 'w-full'
      }`}>
        {/* Header */}
        <div className="flex items-center justify-between p-3 bg-gray-100">
          <div className="flex items-center">
            <div className="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center">
              <User className="h-6 w-6 text-gray-600" />
            </div>
          </div>
          <div className="flex space-x-4">
            <button className="text-gray-600">
              <MoreVertical size={20} />
            </button>
          </div>
        </div>

        {/* Search */}
        <div className="p-2">
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-sm"
              placeholder="Search or start new chat"
            />
          </div>
        </div>

        {/* Contacts list */}
        <div className="overflow-y-auto h-[calc(100%-120px)]">
          {contacts.map((contact) => (
            <div
              key={contact.id}
              className={`flex items-center p-3 border-b border-gray-200 cursor-pointer hover:bg-gray-100 ${
                activeContact && activeContact.id === contact.id ? 'bg-gray-100' : ''
              }`}
              onClick={() => setActiveContact(contact)}
            >
              <div className="relative">
                <img
                  src={contact.avatar}
                  alt={contact.name}
                  className="h-12 w-12 rounded-full"
                />
                {contact.unread > 0 && (
                  <div className="absolute -top-1 -right-1 bg-green-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                    {contact.unread}
                  </div>
                )}
              </div>
              <div className="ml-3 flex-1">
                <div className="flex justify-between items-baseline">
                  <h3 className="text-sm font-semibold">{contact.name}</h3>
                  <span className="text-xs text-gray-500">{contact.time}</span>
                </div>
                <p className="text-xs text-gray-500 truncate w-48">{contact.lastMessage}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right side - Chat area */}
      <div className={`flex-1 flex flex-col ${
        !activeContact && windowWidth < 768 ? 'hidden' : 
        showContactInfo ? 'md:w-2/3' : 'w-full md:w-2/3'
      }`}>
        {/* Chat header */}
        {activeContact && (
          <div className="flex items-center justify-between p-3 border-b border-gray-300 bg-gray-100">
            <div className="flex items-center">
              {windowWidth < 768 && (
                <button 
                  className="mr-2" 
                  onClick={() => setActiveContact(null)}
                >
                  <ChevronLeft size={20} />
                </button>
              )}
              <img
                src={activeContact.avatar || '/api/placeholder/50/50'}
                alt={activeContact.name}
                className="h-10 w-10 rounded-full cursor-pointer"
                onClick={() => setShowContactInfo(true)}
              />
              <div className="ml-3">
                <h3 className="text-sm font-semibold">{activeContact.name}</h3>
                <p className="text-xs text-gray-500">{activeContact.lastSeen}</p>
              </div>
            </div>
          <div className="flex space-x-4">
            <button className="text-gray-600">
              <Phone size={20} />
            </button>
            <button className="text-gray-600">
              <Video size={20} />
            </button>
            <button className="text-gray-600" onClick={() => setShowContactInfo(true)}>
              <Info size={20} />
            </button>
          </div>
        </div>
        )}

        {/* Chat messages */}
        <div 
          className="flex-1 overflow-y-auto p-4 bg-gray-200" 
          style={{ backgroundImage: "url('https://web.whatsapp.com/img/bg-chat-tile-light_04fcacde539c58cca6745483d4858c52.png')" }}
        >
          <div className="flex flex-col space-y-2">
            {messages.map((message) => (
              <div
                key={message.id}
                className={`flex ${message.sender === 'me' ? 'justify-end' : 'justify-start'}`}
                onContextMenu={(e) => handleMessageContextMenu(e, message.id)}
              >
                <div
                  className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg relative ${
                    message.sender === 'me'
                      ? 'bg-green-100 rounded-tr-none'
                      : 'bg-white rounded-tl-none'
                  }`}
                >
                  {message.edited && (
                    <span className="text-xs text-gray-500 mr-1">edited</span>
                  )}
                  <p className="text-sm">{message.text}</p>
                  <div className="flex items-center justify-end mt-1 space-x-1">
                    <span className="text-xs text-gray-500">{message.time}</span>
                    {message.sender === 'me' && (
                      <MessageStatus status={message.status} />
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Message input */}
        <div className="p-3 bg-gray-100 flex items-center">
          <button className="text-gray-600 mx-2">
            <Smile size={24} />
          </button>
          <button className="text-gray-600 mx-2">
            <Paperclip size={24} />
          </button>
          <div className="flex-1 mx-2">
            <input
              type="text"
              className="w-full p-2 rounded-full border border-gray-300 focus:outline-none focus:border-green-500"
              placeholder={editingMessage ? "Edit message..." : "Type a message"}
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              onKeyPress={handleKeyPress}
            />
          </div>
          <button className="text-gray-600 mx-2">
            {newMessage.trim() === '' ? (
              <Mic size={24} />
            ) : (
              <div 
                className="bg-green-500 text-white rounded-full w-10 h-10 flex items-center justify-center"
                onClick={handleSendMessage}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z"
                  />
                </svg>
              </div>
            )}
          </button>
        </div>

        {/* Context menu for messages */}
        {contextMenu.visible && (
          <div
            className="fixed bg-white shadow-lg rounded-md py-1 z-50"
            style={{ top: contextMenu.y, left: contextMenu.x }}
          >
            <div 
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center"
              onClick={() => handleEditMessage(contextMenu.messageId)}
            >
              <Edit size={16} className="mr-2" />
              <span>Edit</span>
            </div>
            <div 
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center text-red-500"
              onClick={() => handleDeleteMessage(contextMenu.messageId)}
            >
              <Trash2 size={16} className="mr-2" />
              <span>Delete</span>
            </div>
          </div>
        )}
      </div>

      {/* Contact Info Panel */}
      {showContactInfo && activeContact && (
        <div className={`${windowWidth < 768 ? 'w-full absolute inset-0 z-10' : 'w-1/3'} border-l border-gray-300 bg-white overflow-y-auto`}>
          <div className="p-4 bg-gray-100 flex items-center">
            <button 
              className="mr-2" 
              onClick={() => setShowContactInfo(false)}
            >
              <ChevronLeft size={20} />
            </button>
            <h2 className="text-lg font-semibold">Contact Info</h2>
          </div>
          
          <div className="p-4 flex flex-col items-center border-b border-gray-200">
            <img
              src={activeContact.avatar || '/api/placeholder/50/50'}
              alt={activeContact.name}
              className="h-32 w-32 rounded-full mb-4"
            />
            <h3 className="text-xl font-semibold">{activeContact.name}</h3>
            <p className="text-sm text-gray-500">{activeContact.lastSeen}</p>
          </div>
          
          <div className="p-4 border-b border-gray-200">
            <h4 className="text-sm text-gray-500 uppercase mb-2">About</h4>
            <p className="text-sm">Hey there! I'm using WhatsApp.</p>
          </div>
          
          <div className="p-4 border-b border-gray-200">
            <h4 className="text-sm text-gray-500 uppercase mb-2">Media, Links and Docs</h4>
            <div className="flex space-x-2">
              <div className="w-20 h-20 bg-gray-300 rounded-md"></div>
              <div className="w-20 h-20 bg-gray-300 rounded-md"></div>
              <div className="w-20 h-20 bg-gray-300 rounded-md"></div>
            </div>
          </div>
          
          <div className="p-4 border-b border-gray-200">
            <div className="flex items-center justify-between text-red-500">
              <span>Block {activeContact.name}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppClone;